// import React from 'react';
// import styled from 'styled-components';

// const SectionContainer = styled.div`
//   padding: 80px 20px;
//   display: flex;
//   background-color:#062c3f;
//   flex-direction: column;
  

//   @media (min-width: 768px) {
//     padding: 80px 110px;
//     flex-direction: row;
//     justify-content: space-between;
//   }
// `;

// const TextContainer = styled.div`
//   max-width: 600px;
//   margin-bottom: 40px;
  
//   @media (min-width: 768px) {
//     max-width: 50%;
//     margin-right: 40px;
//     margin-bottom: 0;
//     text-align: left;
//   }
// `;

// const Heading = styled.h2`
//   font-size: 2.8em;
//   font-weight: 700;
//   line-height: 1.6;
//   color: #fff;
//   margin-bottom: 20px;

//   span {
//     color: #00cbf1;
//   }
// `;

// const SubHeading = styled.p`
//   font-size: 1.1em;
//   color: #fff;
//   line-height: 2.5;
//   margin-bottom: 40px;
//   text-align: justify;
//   font-family: "Poppins", system-ui;
//   font-weight: 400;
//   font-style: normal;
// `;

// const GridContainer = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//   gap: 20px;
//   max-width: 50%;
// `;

// const BenefitCard = styled.div`
//   padding: 25px 0px 25px 0px;
//   text-align: left;
//   width: 100%;

//   @media (max-width: 480px) {
//   width: 135%;
//   }
// `;

// const IconContainer = styled.div`
//   width: 70px;
//   height: 70px;
//   background-color: ${({ bgColor }) => bgColor || '#007bff'};
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 20px;
//   margin-bottom: 20px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
// `;

// const Icon = styled.div`
//   font-size: 28px;
//   color: #06334b;
// `;

// const BenefitTitle = styled.h3`
//   font-size: 22px;
//   font-weight: 600;
//   color: #00cbf1;
//   margin-bottom: 10px;
// `;

// const BenefitDescription = styled.p`
//   font-family: "Poppins", system-ui;
//   font-style: normal;
//   font-size: 16px;
//   font-weight: 400;
//   color: #fff;
//   text-align: justify;
//   line-height: 1.71;
// `;

// const BenefitsSection = () => {
//   return (
//     <SectionContainer>
//       <TextContainer>
//         <Heading>Why You Should Join Our <span>Awesome Team</span> </Heading>
//         <SubHeading>
//         Step into a world where your skills are nurtured, your ambitions are fueled, and your success is celebrated. Discover a career path that’s not just about work, but about passion, innovation, and making a real impact.
//         </SubHeading>
//       </TextContainer>

//       <GridContainer>
//         <BenefitCard>
//           <IconContainer bgColor="#E7F2FF">
//             <Icon><i className="fa-solid fa-users fa-xl"></i></Icon>
//           </IconContainer>
//           <BenefitTitle>Team Work</BenefitTitle>
//           <BenefitDescription>
//             Collaborate with skilled professionals in a supportive and dynamic environment.
//           </BenefitDescription>
//         </BenefitCard>

//         <BenefitCard>
//           <IconContainer bgColor="#FFEEED">
//             <Icon><i className="fa-solid fa-arrow-trend-up fa-xl"></i></Icon>
//           </IconContainer>
//           <BenefitTitle>Upgrade Skills</BenefitTitle>
//           <BenefitDescription>
//             Enhance your expertise with the latest tools and technologies in your field.
//           </BenefitDescription>
//         </BenefitCard>


//         <BenefitCard>
//           <IconContainer bgColor="#F1F7E8">
//             <Icon><i className="fa-solid fa-shield fa-xl"></i></Icon>
//           </IconContainer>
//           <BenefitTitle>Secured Future</BenefitTitle>
//           <BenefitDescription>
//             Benefit from our strong security measures and investment in your long-term success.
//           </BenefitDescription>
//         </BenefitCard>

//         <BenefitCard>
//           <IconContainer bgColor="#EFF2F5">
//             <Icon><i className="fa-solid fa-graduation-cap fa-xl"></i></Icon>
//           </IconContainer>
//           <BenefitTitle>Training</BenefitTitle>
//           <BenefitDescription>
//             Access ongoing training and development to advance your career and skills.
//           </BenefitDescription>
//         </BenefitCard>

      
//       </GridContainer>
//     </SectionContainer>
//   );
// };

// export default BenefitsSection;
import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulseGlow = keyframes`
  from {
    box-shadow: 0 0 0 rgba(45, 212, 191, 0.0);
    transform: translateY(0);
  }
  to {
    box-shadow: 0 0 30px rgba(45, 212, 191, 0.35);
    transform: translateY(-4px);
  }
`;

const SectionContainer = styled.section`
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  background: radial-gradient(circle at top left, #0ea5e9 0, #022c3a 28%, #020617 75%);
  color: #fff;
  font-family: 'Poppins', system-ui;

  @media (min-width: 768px) {
    padding: 80px 110px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

const TextContainer = styled.div`
  max-width: 540px;
  animation: ${fadeInUp} 0.8s ease-out;

  @media (min-width: 768px) {
    max-width: 48%;
  }
`;

const Heading = styled.h2`
  font-size: 2.6rem;
  font-weight: 700;
  line-height: 1.35;
  margin-bottom: 20px;

  span {
    color: #22d3ee;
  }

  @media (max-width: 576px) {
    font-size: 2rem;
  }
`;

const SubHeading = styled.p`
  font-size: 1rem;
  color: #e5e7eb;
  line-height: 1.9;
  margin-bottom: 0;
  text-align: justify;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 540px;
  animation: ${fadeInUp} 0.8s ease-out 0.15s both;

  @media (min-width: 768px) {
    max-width: 48%;
  }
`;

const BenefitCard = styled.div`
  padding: 22px 20px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.4);
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  cursor: default;

  &:hover {
    animation: ${pulseGlow} 0.4s ease-out forwards;
    border-color: rgba(45, 212, 191, 0.8);
  }
`;

const IconContainer = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 14px;
  background-color: ${({ bgColor }) => bgColor || '#e5f2ff'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.div`
  font-size: 26px;
  color: #022c3a;
`;

const BenefitTitle = styled.h3`
  font-size: 1.05rem;
  font-weight: 600;
  color: #22d3ee;
  margin: 0;
`;

const BenefitDescription = styled.p`
  font-size: 0.95rem;
  color: #e5e7eb;
  margin: 0;
  line-height: 1.7;
  text-align: justify;
`;

const BenefitsSection = () => {
  return (
    <SectionContainer>
      <TextContainer>
        <Heading>
          Why You Should Join Our <span>Awesome Team</span>
        </Heading>
        <SubHeading>
          Step into a world where your skills are nurtured, your ambitions are fueled, and your
          success is celebrated. Discover a career path that’s not just about work, but about
          passion, innovation, and making a real impact.
        </SubHeading>
      </TextContainer>

      <GridContainer>
        <BenefitCard>
          <IconContainer bgColor="#E7F2FF">
            <Icon>
              <i className="fa-solid fa-users fa-xl" />
            </Icon>
          </IconContainer>
          <BenefitTitle>Team Work</BenefitTitle>
          <BenefitDescription>
            Collaborate with skilled professionals in a supportive and dynamic environment.
          </BenefitDescription>
        </BenefitCard>

        <BenefitCard>
          <IconContainer bgColor="#FFEEED">
            <Icon>
              <i className="fa-solid fa-arrow-trend-up fa-xl" />
            </Icon>
          </IconContainer>
          <BenefitTitle>Upgrade Skills</BenefitTitle>
          <BenefitDescription>
            Enhance your expertise with the latest tools and technologies in your field.
          </BenefitDescription>
        </BenefitCard>

        <BenefitCard>
          <IconContainer bgColor="#F1F7E8">
            <Icon>
              <i className="fa-solid fa-shield fa-xl" />
            </Icon>
          </IconContainer>
          <BenefitTitle>Secured Future</BenefitTitle>
          <BenefitDescription>
            Grow in a stable, future-ready environment that invests in your long-term success.
          </BenefitDescription>
        </BenefitCard>

        <BenefitCard>
          <IconContainer bgColor="#EFF2F5">
            <Icon>
              <i className="fa-solid fa-graduation-cap fa-xl" />
            </Icon>
          </IconContainer>
          <BenefitTitle>Training</BenefitTitle>
          <BenefitDescription>
            Access ongoing training and development to advance your career and sharpen your skills.
          </BenefitDescription>
        </BenefitCard>
      </GridContainer>
    </SectionContainer>
  );
};

export default BenefitsSection;
